import React from "react";
import { ArrowRight, Button, Card, CardHeader } from "@opendate-app/setlist";
import DetailField from "./DetailField";
import { formatPrice } from "../../../shared/teamCurrencyFormatting";
import { useRegistrationPageContext } from "./RegistrationPageContext";

export default function OrderPaymentCard() {
  const { registration, currencyCode } = useRegistrationPageContext();
  const { order } = registration.dashboard;
  const attendees = order.attendee_count > 1 ? ` · ${order.attendee_count} attendees` : "";

  return (
    <Card header={<CardHeader title="Order & Payment" actions={<Button as="a" variant="link-color" size="sm" trailingIcon={ArrowRight} href={order.path}>View Order</Button>} />}>
      <dl className="row mb-0">
        <DetailField label="Order">{`#${order.id}`}</DetailField>
        <DetailField label="Order total">{`${formatPrice(Number(order.total), currencyCode)}${attendees}`}</DetailField>
        <DetailField label="Payment method">{order.payment_method}</DetailField>
        {registration.comp_reason && <DetailField label="Comp reason">{registration.comp_reason}</DetailField>}
      </dl>
    </Card>
  );
}
